import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(5),
  },
}))(MuiAccordionDetails);

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Card>
      <CardContent style={{margin: "0rem 0rem 8rem"}}>
      <Typography component="h3" variant="h5" align="center" style={{color:"#000" , margin: "5rem 0rem 2rem"}}>
        Frequently Asked Questions (FAQ)
      </Typography>  
      <Grid container  direction="row" justify="center" alignItems="center">
      <Grid item xs={12} sm={6}>
      <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography>Is this platform free to use?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Yes, the VLearnAI platform is free.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography>Does this platform ready to use?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            The VLearnAI currently is still in development progress. 
            It is on-going project supervised by UPM FSKTEM Intelligent System research group.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography>Can I be the instructor to share my knowledge?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Absolutely welcome! We are keen to have more knowledge sharer to join us in this research work and benefits thousands of students.
            Please feel free to contact us.
          </Typography>
        </AccordionDetails>
      </Accordion>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
    </div>
  );
}